import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { MODAL_SIZES, STRATEGY_SETS_RESULTS } from 'shared-modules/constants';
import { useStrategiesSuccess } from 'shared-modules/services/hooks/cartLogic';
import { push } from '../../../../redux/actions';
import { Button, Modal } from '../../../../components';
import styles from './strategiesSuccess.module.scss';
import { HOME } from '../../../../constants';
import RunSuccess from '../RunAutoTradeComponents/RunSuccess';
import RunAllFail from '../RunAutoTradeComponents/RunAllFail';

const StrategiesSuccess = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();
  const { title, info, innerStrategyResults } = useStrategiesSuccess(isOpen);

  const handleRedirectToPortfolio = useCallback(() => {
    closeModal();
    // for waiting close animation
    setTimeout(() => {
      dispatch(push(`/${HOME}`));
    }, 300);
  }, [dispatch, closeModal]);

  const allError = innerStrategyResults.every((strategyResult) => strategyResult.status === STRATEGY_SETS_RESULTS.FAIL);
  const allSuccess = innerStrategyResults.every(
    (strategyResult) => strategyResult.status === STRATEGY_SETS_RESULTS.SUCCESS,
  );

  const successInfo = {
    success: {
      modalTitle: title,
      title: info,
    },
    buttons: {
      submit: {
        label: 'ホーム画面へ',
      },
    },
  };

  const SuccessModal = () => {
    return (
      <RunSuccess
        isOpen={isOpen}
        closeModal={closeModal}
        runNowResultsLogic={successInfo}
        onClickButton={handleRedirectToPortfolio}
      />
    );
  };

  const AllFailedModal = () => {
    return <RunAllFail isOpen={isOpen} closeModal={closeModal} title={title} info={info} />;
  };

  const PartialFailedModal = () => {
    return (
      <Modal isOpen={isOpen} closeModal={closeModal} size={MODAL_SIZES.WIDTH_512} withoutHeader isErrorNotification>
        <div className={styles.errorIconContainer}>
          <i className={classNames('material-icons-outlined', styles.errorIcon)}>error_outline</i>
        </div>
        <div className={styles.errorMessageTitle}>{title}</div>
        <div className={styles.errorMessageInfo}>{info}</div>
        <div className={styles.scrollableInfoContainer}>
          {innerStrategyResults.map((strategyResult) => (
            <div className={styles.setsRow} key={strategyResult.strategyId}>
              <div className={styles.dot}>・</div>
              <div>
                <div className={classNames(styles.strategiesName, styles.text)}>
                  {strategyResult.status === STRATEGY_SETS_RESULTS.FAIL && (
                    <span className={styles.errorMessage}>[失敗] </span>
                  )}
                  {strategyResult.status === STRATEGY_SETS_RESULTS.SUCCESS && (
                    <span className={styles.successMessage}>[成功] </span>
                  )}
                  {strategyResult.strategyName}
                </div>
                {strategyResult.status === STRATEGY_SETS_RESULTS.FAIL && (
                  <div className={classNames(styles.resultMessage, styles.text, styles.errReasonText)}>
                    {strategyResult.errReason}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <Button width={400} className={styles.closeErrorModalButton} onClick={closeModal} secondary>
            とじる
          </Button>
        </div>
      </Modal>
    );
  };

  let modalContent;
  if (allError) {
    modalContent = <AllFailedModal />;
  } else if (allSuccess) {
    modalContent = <SuccessModal />;
  } else {
    modalContent = <PartialFailedModal />;
  }

  return modalContent;
};

StrategiesSuccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default memo(StrategiesSuccess);
